/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/wsp/wsp_Perms.js";

const r = REG.reg;
r.newPerm("action.wsp.histo#change.comment", "write.node.setMeta", 0);
r.newPerm("action.wsp.histo#change.flag", "write.node.setMeta", 0);
r.newPerm("action.wsp.histo#deletePermanently", "write.node.setMeta", 0);
r.newPerm("action.wsp.histo#deletePermanently.mine", "write.node.setMeta", 0);
